import {getAccessAdministrationPermission} from "@project/sdk/access-administration";
import {GetAccessAdministrationPermissionResponse} from "@project/sdk/access-administration/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../shared/query/query-policies";
import {permissionKeys} from "../../access-administration-keys";

export function getPermissionQueryOptions(permissionKey: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: permissionKeys.detail(permissionKey),
    queryFn: async ({signal}) =>
      GetAccessAdministrationPermissionResponse.parse(
        await getAccessAdministrationPermission(permissionKey, {signal}),
      ),
  });
}
